"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserServiceContractStateEnum = void 0;
var UserServiceContractStateEnum;
(function (UserServiceContractStateEnum) {
  /** Разовое занятие */
  UserServiceContractStateEnum["onetime"] = "onetime";
  /** Регулярное занятие */
  UserServiceContractStateEnum["ongoing"] = "ongoing";
  /** Являюсь участником */
  UserServiceContractStateEnum["contracted"] = "contracted";
  /** От меня ожидается подтверждения (оплаты) */
  UserServiceContractStateEnum["accepting"] = "accepting";
  /** Я оплатил/подписался */
  UserServiceContractStateEnum["accepted"] = "accepted";
  /** Я прервал контракт */
  UserServiceContractStateEnum["broken"] = "broken";
  /** Моё участие в контракте отменено */
  UserServiceContractStateEnum["canceled"] = "canceled";
  /** Контракт приостановлен по причине неоплаты */
  UserServiceContractStateEnum["suspended"] = "suspended";
})(UserServiceContractStateEnum = exports.UserServiceContractStateEnum || (exports.UserServiceContractStateEnum = {}));
